export default __webpack_public_path__ + "static/all_forgery_locations-cb8be8bbf3ba985ea44db7560a28bb0e.png";